document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".swatch_c").forEach(function (swatch) {
    swatch.addEventListener("click", function () {
      const parentColorGroup = this.closest(".color-swatches_c");
      parentColorGroup.querySelectorAll(".swatch_c").forEach(function (s) {
        s.classList.remove("selected");
      });
      const variantId = this.dataset.variantId;
      const productHandle = this.dataset.productHandle;

      this.classList.add("selected");
      console.log("Hello");
      const productCard = this.closest(".card__information");
      const productMedia = document.querySelector(`#${productHandle}`);

      if (productCard) {
        const a_link = productCard.querySelector(".full-unstyled-link");
        if (variantId && productHandle && a_link) {
          const pdpUrl = `/products/${productHandle}?variant=${variantId}`;
          a_link.href = pdpUrl;
        }

        var image165 = this.getAttribute("data-variant-image-165");
        var image360 = this.getAttribute("data-variant-image-360");
        var image533 = this.getAttribute("data-variant-image-533");
        var image720 = this.getAttribute("data-variant-image-720");
        var image940 = this.getAttribute("data-variant-image-940");
        var image1066 = this.getAttribute("data-variant-image-1066");

        var productImage = productMedia.querySelector(".card-product-image"); 
        // console.log(productImage);
        if (productImage) {
          productImage.src = image533;
          var newSrcset = "";
          if (image165) newSrcset += image165 + " 165w, ";
          if (image360) newSrcset += image360 + " 360w, ";
          if (image533) newSrcset += image533 + " 533w, ";
          if (image720) newSrcset += image720 + " 720w, ";
          if (image940) newSrcset += image940 + " 940w, ";
          if (image1066) newSrcset += image1066 + " 1066w";

          productImage.setAttribute("srcset", newSrcset);
        }
      }
    });
  });
});
